import { getImageUrl } from './imageUrl';

export const DEFAULT_VIDEO = '/images/hero-video.mp4';
export const DEFAULT_POSTER = '/images/hero-poster.jpg';
const LEGACY_VIDEO = 'https://customer-assets.emergentagent.com/job_summer-invasion/artifacts/2pie12xd_IMG_9572.MP4';
const LEGACY_POSTER = 'https://images.unsplash.com/photo-1573019299719-a930c54b3401?w=1920&q=80';

export function heroMedia(settings = {}, target = 'mobile') {
  const resolve = (value, legacy, fallback) => {
    const path = typeof value === 'string' ? value.trim() : '';
    if (!path || path === legacy) return fallback;
    if (!/^https?:\/\//i.test(path) && !/^\/(?!\/)/.test(path)) return fallback;
    return getImageUrl(path);
  };
  const desktop = target === 'desktop';
  return {
    video: resolve(desktop ? settings.hero_desktop_video_url : settings.hero_video_url, LEGACY_VIDEO, DEFAULT_VIDEO),
    poster: resolve(desktop ? settings.hero_desktop_poster_url : settings.hero_poster_url, LEGACY_POSTER, DEFAULT_POSTER),
  };
}
